import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { jiraHorizontalNavEntrypoint } from '@atlassian/jira-horizontal-nav/entrypoint.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { customerServiceInboxPageEntrypoint } from '@atlassian/jira-spa-apps-software-customer-service-inbox/entrypoint.tsx';

export const inboxPageEntryPoint = createPageEntryPoint({
	main: customerServiceInboxPageEntrypoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
	horizontalNavigation: jiraHorizontalNavEntrypoint,
});
